import { useContext } from "react";
import { Accordion, AccordionContext, useAccordionButton } from "react-bootstrap";
import ButtonOverride from "../../../../components/buttonoverride";
import styles from '../../../../styles/expenditureworksheet.module.css';

const ExepnditureAccordion = ({children}) => {
    return(
        <Accordion defaultActiveKey='0'>
            {children}
        </Accordion>
    )
}

const ExepnditureAccordionToggle = ({children,eventKey,callback}) =>{
    const {activeEventKey} =  useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(
        eventKey,
        () => callback && callback(eventKey),
    );

    const isCurrentEventKey = activeEventKey === eventKey;

    return(
        <ButtonOverride type="button" className={`${styles.accordionToggle} ${isCurrentEventKey ? styles.active : null}`} onClick={decoratedOnClick}>
            {children}
        </ButtonOverride>
    )
}

const ExepnditureAccordionBody = ({eventKey,children}) => {
    const { activeEventKey } = useContext(AccordionContext);

    return(
        activeEventKey === eventKey
        ?   
            <div className={`clientCard ${styles.expenditureBody}`}>
                {children}
            </div>
        :
            <div className='clientCard'>
                {children}
            </div>
    )
}

const ExepnditureAccordionCollapseSection = ({children}) => {
    return(
        <Accordion.Collapse eventKey="0">
            <div className={styles.expenditureSubsectionBody}>
                {children}
            </div>
        </Accordion.Collapse>
    )
}

export {ExepnditureAccordion,ExepnditureAccordionBody,ExepnditureAccordionToggle,ExepnditureAccordionCollapseSection};